import { Divider, Group, List, Stack, Text, Tooltip } from '@mantine/core';
import React from 'react';
import BasePage from '../BasePage';
import { IconCircleCheckFilled, IconCircleDashed, IconClock, IconProgress } from '@tabler/icons-react';

interface Tasks {
    label: string;
    status: "planned" | "in-progress" | "testing" | "implemented"
}

interface RoadmapItem {
    label: string;
    tasks: Tasks[];
}

function RoadmapPage() {
    const roadmapItems: RoadmapItem[] = [
        {
            label: "Setup server-based RBAC",
            tasks: [
                {
                    label: "Database models and connections",
                    status: "implemented"
                },
                {
                    label: "Server configuration",
                    status: "implemented"
                },
                {
                    label: "API endpoints",
                    status: "implemented"
                },
                {
                    label: "Restrict API calls based on role",
                    status: "implemented"
                },
                {
                    label: "Restrict frontend based on role",
                    status: "implemented"
                }
            ]
        },
        {
            label: "Offboarding",
            tasks: [
                {
                    label: "Allow user to look up list of employees",
                    status: "implemented"
                },
                {
                    label: "One-click offboarding",
                    status: "implemented"
                },
                {
                    label: "Setup celery in the backend to schedule offboarding",
                    status: "in-progress"
                },
                {
                    label: "Get a list of offboarding tasks and automate it",
                    status: "implemented"
                }
            ]
        },
        {
            label: "Configurable Entra Connection",
            tasks: [
                {
                    label: "Database models and connections",
                    status: "planned"
                },
                {
                    label: "API endpoints",
                    status: "planned"
                },
                {
                    label: "Dynamic MSAL config from the frontend",
                    status: "planned"
                },
                {
                    label: "Edit configuration in the backend from the UI",
                    status: "planned"
                }
            ]
        }
    ]

    return (
        <BasePage
            title="Roadmap"
            desc="Unify development progress"
            breadcrumbs={[
                { label: "Roadmap" }
            ]}
            fullWidth
            withDivider>
            <Group align="start">
                {roadmapItems.map((item, index) =>
                    <Stack
                        key={index}
                        style={{
                            width: "400px",
                            border: "1px solid var(--border-color)",
                            borderRadius: "8px",
                            padding: "16px",
                            overflow: "hidden"
                        }}
                    >
                        <Tooltip label={item.label} position="bottom">
                            <Text ta="center">{item.label}</Text>
                        </Tooltip>

                        <Divider />

                        <List w="fit" spacing="xs" size="sm" center>
                            {item.tasks.map((task, index) =>
                                <Tooltip label={task.label} position="bottom">
                                    <List.Item
                                        key={index}
                                        icon={
                                            (task.status === "planned" && <IconClock size={"1.5rem"} />) ||
                                            (task.status === "in-progress" && <IconProgress size={"1.5rem"} />) ||
                                            (task.status === "testing" && <IconCircleDashed size={"1.5rem"} />) ||
                                            (task.status === "implemented" && <IconCircleCheckFilled size={"1.5rem"} color="#12b886" />)
                                        }
                                    >
                                        <Text>{task.label}</Text>
                                    </List.Item>
                                </Tooltip>
                            )}
                        </List>
                    </Stack>
                )}
            </Group>
        </BasePage>
    )
};

export default RoadmapPage;